import { useState } from "#app";

export type HeaderStyle = "transparent" | "opaque" | "inverted" | "background";

export const useHeaderStyle = (setStyle?: HeaderStyle) => {
  const headerStyle = useState<HeaderStyle>(
    "headerStyle",
    () => setStyle ?? "transparent",
  );
  const setHeaderStyle = (style: HeaderStyle) => {
    headerStyle.value = style;
  };

  return {
    setHeaderStyle,
    headerStyle,
  };
};
